MultiVariant = (function() {
  var filter = "";
  var jsonData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
  var productData = jsonData['product'];
  var variantOptionName = jsonData['product'].options[0].toLowerCase();
  var productVariantImages = document.getElementsByClassName('Product__SlideItem--image');
  var productNavVariantImages = document.getElementsByClassName('Product__SlideshowNavImage');
  var mediaByVaraint = getMediaIndexByVariant();
  var variantImages = getMediaByVariant();
  var variantThumbnails = getThumbnailSourceByVariant();
  var allElements = [];

  // Get childnodes
  for (var i = 0; i < productVariantImages.length; i++) {
    allElements.push(productVariantImages[i]);
  }

  // We init value with the first selected variant
  productData['variants'].forEach(function(variant) {
    if (variant['id'] === jsonData['selected_variant_id']) {
      reduceVariantImages(variant);
      filterVariantImages(variant);
    }
  });

  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details
    filterVariantImages(variant);
  });

  function reduceVariantImages(selectedVariant) {
    filter = variantOptionName + "_" + serializeFilter(selectedVariant);

    var mediaPositions = mediaByVaraint.get(filter);
    if (mediaPositions.length > 1) {
      for (var [key, value] of mediaPositions.entries()) {
  	    removeVariantChildNodes(productVariantImages, filter, mediaPositions);
        removeVariantThumbnails(productNavVariantImages, filter)
	  }
    } else {
      productData['variants'].forEach(function(variant) {
        removeVariantChildNodes(productVariantImages, filter, mediaPositions);
        removeVariantThumbnails(productNavVariantImages, filter)
      });
    }
  }


  function filterVariantImages(selectedVariant) {
    filter = variantOptionName + "_" + serializeFilter(selectedVariant);

    // Hide Page dots mobile nav
    hidePageDotsOnMobile(mediaByVaraint.get(filter));

    // Filter Thumbnail images
    //showVariantImages(productNavVariantImages, filter, "inline-block");

    // Change images
    changeImages(productVariantImages, filter);

    // Change thumbnails
    changeThumbnails(productNavVariantImages, filter);
  }

  function serializeFilter(variant) {
    var variantTitle = variant.title;
    if (variantTitle.includes(" ")) {
      console.log('space');
      var replacedSpecialChars = variantTitle.replace(/ /g, '-')
    } else {
      var replacedSpecialChars = variantTitle.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '-')
    }
    
    return replacedSpecialChars.toLowerCase();
  }

  function changeImages(elements, filter) {
    var images = variantImages.get(filter);
    for (var i = 0; i < images.length; i++) {
      // Overwrite media position - fix error reloading varinat page
      elements[i].dataset.mediaPosition = i + 1;
      elements[i].dataset.imageMediaPosition = i;
      var mediaElement = elements[i].querySelector("div");
      mediaElement.replaceChild(images[i], mediaElement.childNodes[1]);
    }
  }

  function changeThumbnails(elements, filter) {
    var src = variantThumbnails.get(filter);
    for (var i = 0; i < src.length; i++) {
      elements[i].href = src[i]
      elements[i].querySelector("img").src = src[i];

    }
  }

  function hidePageDotsOnMobile(visiblePositions) {
    var buttons = document.querySelectorAll(".flickity-page-dots > button");

    for (var i = 0; i < buttons.length; i++) {
      var index = buttons[i].dataset.index;
      if (index > 4) {
        buttons[i].remove();
      }
    }
  }

  function showVariantImages(elements, filter, display) {
    for (var i = 0; i < elements.length; i++) {
      if (filter == elements[i].dataset.variantType || elements[i].dataset.variantType == "default_variant") {
        elements[i].style.display = display;
      } else {
        elements[i].style.display = "none";
      }
    }
  }

  function getMediaIndexByVariant() {
  	var mediaIndex = new Map();
    var element = document.getElementsByClassName('Product__SlideItem');
    for (var i = 0; i < element.length; i++) {
      var key = element[i].querySelector('div > img').alt.replace('#','');
      var value = element[i].dataset.imageMediaPosition;
      if (mediaIndex.get(key)) {
          var values = mediaIndex.get(key);
          values.push(value);
          mediaIndex.set(key, values);
      } else {
          mediaIndex.set(key, [value]);
      }

    }
  	return mediaIndex;
  }

  function getMediaByVariant() {
  	var media = new Map();
    var element = document.getElementsByClassName('Product__SlideItem');
    for (var i = 0; i < element.length; i++) {
      var key = element[i].querySelector('div > img').alt.replace('#','');
      var value = element[i].querySelector('div > img');
      if (media.get(key)) {
          var values = media.get(key);
          values.push(value);
          media.set(key, values);
      } else {
          media.set(key, [value]);
      }

    }
  	return media;
  }

  function getThumbnailSourceByVariant() {
  	var media = new Map();
    var element = productNavVariantImages;
    for (var i = 0; i < element.length; i++) {
      var key = element[i].dataset.variantType;
      var value = element[i].href;
      if (media.get(key)) {
          var values = media.get(key);
          values.push(value);
          media.set(key, values);
      } else {
          media.set(key, [value]);
      }

    }
  	return media;
  }


  function removeVariantChildNodes(elements, filter, mediaPositions) {
    var length = elements.length;
    for (var i = length -1; i >= 0; i--) {
      var mediaPosition = elements[i].dataset.imageMediaPosition;
      if (!mediaPositions.includes(mediaPosition)) {
        elements[i].remove();
      }
    }
  }

  function removeVariantThumbnails(elements, filter, mediaPositions) {
    var length = elements.length;
    for (var i = length -1; i >= 0; i--) {
      if (elements[i].dataset.variantType != filter) {
        elements[i].remove();
      }
    }
  }

})();
